export const addresses = {
    1: {
        FCT_Controller: "0x0A0ea58E6504aA7bfFf6F3d069Bd175AbAb638ee",
        FCT_BatchMultiSig: "0x74fe4729c31002c817a2c57cbe67fa37e62cf2f0",
        FCT_EnsManager: "0x30B25912faeb6E9B70c1FD9F395D2fF2083C966C",
        FCT_Tokenomics: "0xB6E0d8DCc868061faAf38D3Bf00793592ff68484",
        Actuator: "0x1332e1A702DaC73523708F95827E6b706DAE5fD9",
        ActuatorCore: "0xde841c9344E3C770a59102C8E61AFF699D8c4585",
        WETH: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    },
    5: {
        FCT_Controller: "0x38B5249Ec6529F19aee7CE2c650CadD407a78Ed7",
        FCT_BatchMultiSig: "0x9F8Cc08FC5293D76A0d8B3b0924742FC36a1301c",
        FCT_EnsManager: "0xB9DBD91e7cC0A4d7635d18FB33416D784EBe2524",
        FCT_Tokenomics: "0x47Fca35c6fAb9E90a1ccf2630941fF64866fD3d2",
        Actuator: "0x862A8FB429195d735106c06C4e352E305d8c7B31",
        ActuatorCore: "0x2301F7d5A833395733F92fdf68B8Eb15aC757dF9",
        WETH: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    },
    42161: {
        FCT_Controller: "0x7A45405D953974998fc447C196Fb015DC41C0650",
        FCT_BatchMultiSig: "0x2174679B326bE7B0888b54CaAdE1FE644DCfd309",
        FCT_EnsManager: "0xa51b9A359A87dB485Fcb87C358C58b123C2f9688",
        FCT_Tokenomics: "0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193",
        Actuator: "0x4171ef9EB2CF074ECaA058Bd8e0F109C0ad4C6d1",
        ActuatorCore: "0x27C133a452303195b237fe920442891FeF609c54",
        WETH: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    },
    421613: {
        FCT_Controller: "0x574F4cDAB7ec20E3A37BDE025260F0A2359503d6",
        FCT_BatchMultiSig: "0x3628BE9E0BEfE4406cDFCA72E51d40d3902B9a22",
        FCT_EnsManager: "0x40b3dA447BE499e0D8165b314EB77e2356d0a92f",
        FCT_Tokenomics: "0x4F741c8106a01d7bAd583aB8937B625d662F0530",
        Actuator: "0x0E3b88a54b4ac2cAA5aD69E5B2E8254dB669c5d7",
        ActuatorCore: "0xfE406d3285a6C5D45Dad771aaD1BD7dADcDb00A0",
        WETH: "0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF",
    },
    11155111: {
        FCT_Controller: "0x1Bc4e8448E6B6703c7458C4Ee8361eB6c3015fD4",
        FCT_BatchMultiSig: "0x4F741c8106a01d7bAd583aB8937B625d662F0530",
        FCT_EnsManager: "0xE611349eD47064a1628204811e93090C018fD93b",
        FCT_Tokenomics: "0xBdc6fA7Af132d04C57DCD69C688eF3802a91bef2",
        Actuator: "0x3628BE9E0BEfE4406cDFCA72E51d40d3902B9a22",
        ActuatorCore: "0xE8572102FA6AE172df00634d5262E56ee283C134",
        WETH: "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9",
    },
};
//# sourceMappingURL=addresses.js.map